import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    items: [],
    count: 0,
    amount: 0,
}

export const favoriteSlice = createSlice({
    name: 'favorite',
    initialState,
    reducers: {
        addFavoriteItem: (state, action) => {
            const existItem = state.items.find(
                (product) => product.product_id === action.payload.product_id
            )
            if (!existItem) {
                state.items = [...state.items, action.payload]
                state.count += 1
                state.amount += parseInt(action.payload.price)
            }
        },
        removeFavoriteItem: (state, action) => {
            const existItem = state.items.find(
                (product) => product.product_id === action.payload.product_id
            )
            if (existItem) {
                state.items = state.items.filter(
                    (product) => product !== existItem
                )
                state.count -= 1
                state.amount -= parseInt(existItem.price)
            }
        },
    },
})
export const { addFavoriteItem, removeFavoriteItem } = favoriteSlice.actions
export default favoriteSlice.reducer
